export default __webpack_public_path__ + "f80816a5455d171f948d98c32f20c46e.ttf";